exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "th, td {\n  border-top: none;\n  border-bottom: none;\n  padding: 1.3%;\n  text-align: center;\n  -ms-flex-item-align: center;\n      -ms-grid-row-align: center;\n      align-self: center; }\n\n.table thead th {\n  border: none !important; }\n\n.table {\n  border-collapse: unset; }\n\n.floatRight {\n  float: right; }\n\n.floatLeft {\n  float: left; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/cut-cable-modal/cut-cable-table/cut-cable-table.component.scss
// module id = ../../../../../src/app/cut-cable-modal/cut-cable-table/cut-cable-table.component.scss
// module chunks = main